const isAdvancedBlock = definition => Boolean(definition.advanced)

export const isBlockDisabled = (definition, layout) => {
  return !definition.allowsMultiple && layout.some(item => item.i === definition.id)
}

export const getEssentialBlockDefinitions = definitions => {
  return definitions.filter(definition => !isAdvancedBlock(definition))
}

export const getAdvancedBlockDefinitions = definitions => definitions.filter(isAdvancedBlock)
